import { Component, DataForColumn } from '../../types'
import _ from 'lodash'
import { getColumnOverrides } from './components/column'
import { ComponentMetaData, MeshContainerContentArea } from '@wix/thunderbolt-becky-types'
import { MeshComponent } from '../../types/mesh'

type Options = {
	isMobileView: boolean
	siteWidth: number
	compProp: { [key: string]: any }
	compData: { [key: string]: any }
	dataForColumn: Partial<DataForColumn>
	componentType: string
	compId: string
	headerBottom: number
	components: Array<MeshComponent>
	compMetaData: Component['metaData']
	skinName: string
	contentArea?: MeshContainerContentArea
}

const getPageMinHeight = (compProps: ComponentMetaData['pageMeshOverrides'], isMobileView: boolean): number => {
	const pageMinHeightDefault = isMobileView ? 200 : 500
	const deviceCompProp = isMobileView ? compProps.mobile : compProps.desktop
	return (deviceCompProp && deviceCompProp.minHeight) || pageMinHeightDefault
}
const isMasterPageSoapContainer = (compId: string) =>
	compId.startsWith('soapBeforePagesContainer') || compId.startsWith('soapAfterPagesContainer')

const getCompsWithHeaderOffset = (components: Array<MeshComponent>, headerBottom: number) =>
	components.map((comp) => ({
		...comp,
		top: comp.top - headerBottom,
	}))

export const getMeshOverrides = (options: Options) => {
	const {
		isMobileView,
		siteWidth,
		headerBottom,
		compProp = {},
		compData = {},
		dataForColumn,
		componentType,
		compId,
		components = [],
		compMetaData,
		contentArea = { alignment: 0.5, width: siteWidth },
	} = options

	const defaultOptions = { width: '100%', contentArea }

	const getPopupContainerOverrides = (overrides?: ComponentMetaData['popupContainerMeshOverrides']) =>
		overrides &&
		_.pickBy({
			fitToContentHeight: overrides.alignmentType === 'fullHeight',
			width: overrides.alignmentType === 'fullWidth' ? '100%' : false,
			contentArea: overrides.alignmentType === 'fullWidth' ? contentArea : false,
		})

	const getPageComponentOverrides = (overrides?: ComponentMetaData['pageMeshOverrides']) =>
		overrides && {
			...defaultOptions,
			fitToContentHeight: true,
			fitToContentPadding: '0px',
			minHeight: getPageMinHeight(overrides, isMobileView),
		}

	const soapContainerOverrides = {
		...defaultOptions,
		fitToContentHeight: true,
	}

	const groupOverrides =
		getPageComponentOverrides(compMetaData?.pageMeshOverrides) ||
		getPopupContainerOverrides(compMetaData?.popupContainerMeshOverrides) ||
		{}

	const compTypeOverrides: { [compType: string]: object } = {
		FooterContainer: defaultOptions,
		HeaderContainer: defaultOptions,
		ScreenWidthContainer: defaultOptions,
		InlinePopup: defaultOptions,
		// 'HoverBox': defaultOptions,
		Column:
			!isMobileView && componentType === 'Column'
				? getColumnOverrides(compId, dataForColumn, compProp.alignment, siteWidth, isMobileView)
				: {},
		StateBoxState: defaultOptions,
		StateStripState: defaultOptions,
		MediaContainer: { width: '100%' },
		ClassicSection: { width: '100%', contentArea },
		StateBoxFormState: defaultOptions,
		PopupContainer: getPopupContainerOverrides(compProp as ComponentMetaData['popupContainerMeshOverrides'])!,
		RefComponent: { fitToContentHeight: true },
		MenuContainer: { fitToContentHeight: true },
		SoapContainer: soapContainerOverrides,
		SlideShowSlide: compData.type === 'StripContainerSlideShowSlide' ? defaultOptions : {},
		MeshGroup: isMasterPageSoapContainer(compId)
			? {
					...defaultOptions,
					fitToContentHeight: true,
					components: getCompsWithHeaderOffset(components, headerBottom),
			  }
			: {},
		Group: groupOverrides,
	}

	return compTypeOverrides[componentType] || {}
}
